"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.whenNot = exports.when = exports.whenSome = exports.whenAll = void 0;

var _castArray = _interopRequireDefault(require("lodash/castArray"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var parseArgs = function parseArgs(propOrConditions, valuesOrCSS, maybeCSS) {
  if (Array.isArray(propOrConditions)) {
    return {
      conditions: propOrConditions,
      styles: valuesOrCSS
    };
  }

  var styles = maybeCSS === undefined ? valuesOrCSS : maybeCSS;
  var conditions = [maybeCSS === undefined ? [propOrConditions] : [propOrConditions, (0, _castArray.default)(valuesOrCSS)]];
  return {
    conditions: conditions,
    styles: styles
  };
};

var customWhen = function customWhen(test) {
  return function (conditions, styles) {
    return function (props) {
      return conditions[test](function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
            prop = _ref2[0],
            _ref2$ = _ref2[1],
            value = _ref2$ === void 0 ? true : _ref2$;

        return Array.isArray(value) ? value.includes(props[prop]) : props[prop] === value;
      }) ? styles : null;
    };
  };
};
/**
 * Applies the styles if all conditions are fulfilled.
 *
 * styled.div`
 *   ${whenAll([['disabled', false], ['color', 'red']], css({ color: 'red' }))}
 * `
 */


var whenAll = customWhen('every');
/**
 * Applies the styles if any of the conditions fulfils.
 *
 * styled.div`
 *   ${whenSome([['disabled', true], ['color', 'gray']], css({ color: 'gray' }))}
 * `
 */

exports.whenAll = whenAll;
var whenSome = customWhen('some');
/**
 * This util is useful when you just want to apply some styles if a component
 * has a specific prop set to a value. Example uses:
 *
 * styled.div`
 *   /// tests if a specific prop was set to a specific value
 *   ${when('color', 'red', css({ color: 'red' }))}
 *
 *   /// tests if a specific prop was set to any of a list of values
 *   ${when('status', ['error', 'warning'], css({ borderColor: 'red' }))}
 *
 *   /// tests if a specific prop was set to the boolean "true"
 *   ${when('isDisabled', , css({ color: 'gray' }))}
 * `
 */

exports.whenSome = whenSome;

var when = function when(propOrConditions, valuesOrCSS, maybeCSS) {
  var _parseArgs = parseArgs(propOrConditions, valuesOrCSS, maybeCSS),
      conditions = _parseArgs.conditions,
      styles = _parseArgs.styles;

  return whenAll(conditions, styles);
};
/**
 * Same as `when` above, but tests that the values do **not** match the prop name.
 */


exports.when = when;

var whenNot = function whenNot(propOrConditions, valuesOrCSS, maybeCSS) {
  return function (props) {
    var _parseArgs2 = parseArgs(propOrConditions, valuesOrCSS, maybeCSS),
        conditions = _parseArgs2.conditions,
        styles = _parseArgs2.styles;

    return whenAll(conditions, true)(props) ? null : styles;
  };
};

exports.whenNot = whenNot;